import CallError from '../../utils/CallError';
import Settings from '../../utils/Settings';
import { getBadParams, getMissingKeys } from '../../utils/general';

export const settings = new Settings();

/**
 * Gets the ECAPPS for a specific org
 * @param {object} params - an object of params
 * @param {string} params.route - route
 * @param {string} params.action - action performed (ex:install)
 * @param {object} params - an object which contains appID
 */

export default async (params, signal = null) => {
  const requiredParams = ['route', 'action', 'params'];
  const paramsRules = {
    route: { allowedTypes: ['string'] },
    action: { allowedTypes: ['string'] },
    params: { allowedTypes: ['object'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${settings.endpoint}/v1/ccd/deeplink`, {
    signal,
    method: 'POST',
    headers: { 'x-api-key': settings.apiKey, 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify({ route: params.route, action: params.action, params: params.params }),
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};
